export const plus = 'M110,242h35V15H110ZM14,111v35H241V111Z'
